import { useFetchWorkspaces } from "features/workspaces/hooks/useFetchWorkspaces";
import { useFetchValidationTemplates } from "features/languages/hooks/useFetchValidationTemplates";
import { Loading } from "@components";
import { Tree } from "../components/Tree/Tree";

export const RulesAssignTab = () => {
  const [workspace, isLoadingWorkspaces] = useFetchWorkspaces();
  const [validationTemplates, isLoadingTemplates] = useFetchValidationTemplates();

  if (isLoadingWorkspaces || isLoadingTemplates) {
    return <Loading />;
  }

  if (!workspace || !validationTemplates) {
    return "Validation rules are not available";
  }

  return <Tree workspace={workspace} validationTemplates={validationTemplates} />;
};
